"use client"

import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { useNavigate } from "react-router-dom"
import { IoClose, IoMenu } from "react-icons/io5"
import {
  FaUserGraduate,
  FaSchool,
  FaChalkboardTeacher,
  FaImages,
  FaShoppingCart,
  FaCalendarAlt,
  FaBlog,
  FaTrophy,
  FaBoxOpen,
  FaVideo,
  FaCheckCircle,
  FaSignOutAlt,
} from "react-icons/fa"

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const closeSidebar = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 640) {
        setIsOpen(true)
      } else {
        setIsOpen(false)
      }
    }

    window.addEventListener("resize", handleResize)
    handleResize()

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const logoutHandler = async () => {
    try {
      await logout()
      alert("Logged Out")
      navigate("/")
    } catch (error) {
      console.error("Error logging out:", error)
    }
  }

  const menuItems = [
    { path: "/students", icon: FaUserGraduate, label: "Students" },
    { path: "/academy", icon: FaSchool, label: "Academy" },
    { path: "/coach", icon: FaChalkboardTeacher, label: "Coach" },
    { path: "/banner", icon: FaImages, label: "Banner" },
    { path: "/product", icon: FaShoppingCart, label: "Product" },
    { path: "/events", icon: FaCalendarAlt, label: "Events" },
    { path: "/blogs", icon: FaBlog, label: "Blogs" },
    { path: "/ChallengeDetails", icon: FaTrophy, label: "Challenges" },
    { path: "/OrderTable", icon: FaBoxOpen, label: "Orders" },
    { path: "/LearningVideo", icon: FaVideo, label: "Learning Videos" },
    { path: "/verifyrequests", icon: FaCheckCircle, label: "Verify Request" },
  ]

  return (
    <>
      <button
        type="button"
        onClick={toggleSidebar}
        className="fixed top-4 right-4 z-50 inline-flex items-center p-2 text-sm text-[#12143F] rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
        <span className="sr-only">Toggle sidebar</span>
        {isOpen ? <IoClose className="w-6 h-6" /> : <IoMenu className="w-6 h-6" />}
      </button>

      <aside
        className={`fixed top-0 left-0 z-40 w-64 h-screen transition-all duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0`}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-[#12143F] text-white">
          <div className="flex justify-between items-center mb-8">
            <span className="text-2xl font-bold">Admin Panel</span>
          </div>
          <nav>
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center p-2 rounded-lg transition-colors duration-150 ease-in-out ${
                      location.pathname === item.path
                        ? "bg-white bg-opacity-10 text-white"
                        : "text-gray-300 hover:bg-white hover:bg-opacity-5 hover:text-white"
                    }`}
                    onClick={closeSidebar}
                  >
                    <item.icon className="w-5 h-5 mr-3" />
                    <span className="text-sm font-medium">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <button
              onClick={logoutHandler}
              className="flex items-center justify-center w-full p-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors duration-150 ease-in-out"
            >
              <FaSignOutAlt className="w-5 h-5 mr-2" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  )
}

export default Sidebar

